import React from "react";
import "./ThemeSwitcher.css";
import { useTheme } from "../../context/ThemeContext";
import { FaSun, FaMoon } from "react-icons/fa";

const ThemeToggle = ({ page, isMobile }) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`theme-toggle`}>
            <div className={`toggle-slider ${theme}`} style={page === "studentPage" || isMobile ? { backgroundColor: theme === "light" ? '#E6F1FF' : '#232323' } : {}} onClick={toggleTheme}>
                <div className="toggle-thumb">
                    {theme === "light" ? <FaSun className="icon" /> : <FaMoon className="icon" />}
                </div>
            </div>
        </div>
    );
};

export default ThemeToggle;
